import { Button, makeStyles, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import logo from './logo.png'
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles({
  main: {
    display: 'flex',
    flexDirection: 'column',
  },
  textBox: {
    margin: '1em'
  },
});

const trim = (text: string) => {
  return text.trim()
    .replace(/^[#,\s]*/, '')
    .replace(/[#,\s]*$/, '')
    .replace(/,\s*,/, ',')
    .replace(/#\s*#/, '#')
    .replace(/\n[xX]\n/g, '\n')
    .replace(/\n[,\s]*\n/g, '\n');
}
const split = (text: string) => {
  const trimmed = trim(text);
  return trimmed.length > 0 ? trimmed.split(/[,#\n]/g).map(s => s.trim()) : [];
}
const count = (text: string) => {
  return split(text).length;
}
const prependHashtag = (text: string) => {
  return text.length > 0 && !text.startsWith('#') ? `#${text}` : text;
}

export default function Keywords() {
  const classes = useStyles();

  const [pasted, setPasted] = useState(false);
  const [state, setState] = useState('');

  const tokens = split(state);
  const duplicates = Array.from(new Set(tokens.filter(token => tokens.filter(match => match === token).length > 1)));

  const onList = () => {
    setState(prev => trim(prev.replace(/\s*[,#]\s*/g, '\n')));
  }
  const onCommas = () => {
    setState(prev => trim(prev.replace(/\s*[#\n]\s*/g, ', ')));
  }
  const onHashtags = () => {
    setState(prev => prependHashtag(trim(prev.replace(/\s*[,\n]\s*/g, ' #'))));
  }
  const onCopy = () => {
    navigator.clipboard.writeText(state).catch(err => console.error(`Error writing to clipboard: ${err}`));
  }
  const onPaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
    setPasted(true);
  }
  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    let str = e.target.value;
    if (pasted) {
      str = trim(str);
    }
    setState(str);
    setPasted(false);
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
      <main className={classes.main}>
        <TextField
          multiline
          rows={20}
          className={classes.textBox}
          label={count(state).toString()}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          value={state}
          onChange={event => onChange(event)}
          onPaste={event => onPaste(event)}
        />
        <div>
          <Button variant='contained' onClick={onList}>
            List
          </Button>
          &nbsp;
          <Button variant='contained' onClick={onCommas}>
            Commas
          </Button>
          &nbsp;
          <Button variant='contained' onClick={onHashtags}>
            Hashtags
          </Button>
          &nbsp;
          <Button variant='contained' onClick={onCopy}>
            Copy
          </Button>
        </div>
        {duplicates.length > 0 && (
          <Snackbar
            open={duplicates.length > 0}
            autoHideDuration={undefined}
          >
            <Alert
              elevation={6}
              severity={'warning'}
              variant="filled"
            >
              Duplicates: {duplicates.join(', ')}
            </Alert>
          </Snackbar>
        )}
      </main>
    </div>
  );
}